import { render, staticRenderFns } from "./AccountDashboard.vue?vue&type=template&id=a3f7d310&scoped=true"
import script from "./AccountDashboard.vue?vue&type=script&lang=js"
export * from "./AccountDashboard.vue?vue&type=script&lang=js"
import style0 from "./AccountDashboard.vue?vue&type=style&index=0&id=a3f7d310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f7d310",
  null
  
)

export default component.exports